import React from "react"

import Typography from "../../../../components/shared/Typography"

const BackgroundColorToggle = ({ formData, onFormDataChange, onSettingsChange, disabled = false, sectionType }) => {
  // Sections that should always use white background (no toggle needed)
  const alwaysWhiteSections = ["hero", "credentials", "keywords", "cta_banner", "quote"]

  // If this section should always be white, don't show the toggle
  if (alwaysWhiteSections.includes(sectionType)) {
    return null
  }

  const enabled = formData?.settings?.showBackgroundColor || false

  const handleToggle = (newValue) => {
    // Use onSettingsChange if available (for live updates), otherwise fall back to onFormDataChange
    if (onSettingsChange) {
      // Update both settings - React will batch these synchronous updates
      // The functional updates in handleSettingsChange ensure we always use the latest state
      onSettingsChange("showBackgroundColor", newValue)
      onSettingsChange("backgroundColor", newValue ? "theme" : "#ffffff")
    } else if (onFormDataChange) {
      onFormDataChange({
        ...formData,
        settings: {
          ...formData.settings,
          showBackgroundColor: newValue,
          backgroundColor: newValue ? "theme" : "#ffffff"
        }
      })
    }
  }

  return (
    <div className="space-y-3">
      <div className="border-b border-gray-200 pb-4">
        <Typography variant="h5" className="font-bold text-gray-dark">
          Section background color
        </Typography>
        <Typography variant="body" className="mt-1 text-gray-600">
          Include a background color in this section.
        </Typography>
      </div>

      <div className="flex items-center justify-between">
        <div className="flex-1">
          <Typography variant="body" className="font-medium text-gray-dark">
            Background color
          </Typography>
          <Typography variant="small" className="mt-1 text-gray-600">
            {enabled ? "Using theme's light background color" : "Using neutral white background"}
          </Typography>
        </div>

        <button
          type="button"
          onClick={() => !disabled && handleToggle(!enabled)}
          disabled={disabled}
          className={`
            relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2
            ${enabled ? "bg-teal-600" : "bg-gray-200"}
            ${disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"}
          `}>
          <span
            className={`
              inline-block h-4 w-4 rounded-full bg-white transition-transform
              ${enabled ? "translate-x-6" : "translate-x-1"}
            `}
          />
        </button>
      </div>
    </div>
  )
}

export default BackgroundColorToggle
